import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ReactDOM from 'react-dom';

const ToolTipWrp = styled('div')`
  transition: opacity 0.1s ease, transform 0.2s ease;
  background-color: #373e44;
  border-radius: 6px;
  cursor: pointer;
  display: block;
  padding: 8px 10px 9px;
  z-index: 100;
  position: absolute;
  color: white;
  height: 35px;
  font-size: 11px;
  text-align: center;
  line-height: 17px;
  top: -19px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.5));
`;

const Caret = styled('div')`
  left: calc(50% - 6px);
  display: block;
  position: absolute;
  bottom: -6px;
  border-style: solid;
  border-width: 6px 6px 0 6px;
  border-color: #373e43 transparent transparent transparent;
`;

export class ToolTip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rightPixelsToAdd: 0
    };
  }

  componentDidMount() {
    const wrapper = ReactDOM.findDOMNode(this.wrapper);
    const width = wrapper.getBoundingClientRect().width;
    this.setState({
      rightPixelsToAdd: -width / 2 + 15
    });
  }

  render() {
    const { wrapperStyle } = this.props;

    const style = Object.assign({}, { right: this.state.rightPixelsToAdd + 'px' }, wrapperStyle);

    return (
      <ToolTipWrp ref={wrapper => (this.wrapper = wrapper)} style={style}>
        {this.props.children}
        <Caret />
      </ToolTipWrp>
    );
  }
}

ToolTip.defaultProps = {
  wrapperStyle: {}
};

ToolTip.propTypes = {
  wrapperStyle: PropTypes.object
};
